import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { AdminUserResponse } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

interface AdminUserQueryVariables {
  userId: string
}

export const useAdminUser = (variables: AdminUserQueryVariables) => {
  const fetchWithAuth = useFetchWithAuth()
  const { userId } = variables

  const getAdminUser: QueryFunction<AdminUserResponse> = async () => {
    if (!userId) {
      throw new Error('User ID is required to fetch admin user')
    }

    const response = await fetchWithAuth(`${URL}/roles/user/${userId}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    return response
  }

  const result = useQuery({
    queryKey: ['adminUser', userId] as const,
    queryFn: getAdminUser,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!userId,
  })

  return {
    data: { response: { user: result.data } },
    error: result.error,
    loading: result.isLoading,
    networkStatus: result.status,
    user: result.data,
    userErrors: null,
  }
}
